import { useCallback } from "react";

import { useAnalytics } from "../context/AnalyticsContext";
import { useProposalEdits } from "../context/ProposalEditsContext";

export type ProposalEditResetSurface = "chat_card" | "drawer";

export type ResetProposalEdit = (actionId: string, cardKind: string, surface: ProposalEditResetSurface) => void;

export function useResetProposalEdit(conversationId: string): ResetProposalEdit {
  const { clearEdit } = useProposalEdits();
  const { analytics } = useAnalytics();
  return useCallback((actionId, cardKind, surface) => {
    clearEdit(conversationId, actionId);
    analytics?.track("proposal_edit_reset", { conversationId, actionId, cardKind, surface });
  }, [clearEdit, analytics, conversationId]);
}
